






import Vue from 'vue'
export default Vue.extend({
  name: 'bonus-base',
  props: {
    bonus: {
      type: Object,
      required: true,
    },
  },
})
